// config
import Config from "Config";

// dependencies
import moment from "moment";
import { Map } from "immutable";
import { createSelector } from "reselect";
import { getMatchedRoute, getMatchedRouteKeyValue } from "yarrr";

export const getPageName = (state) => {
	const matchedRoute = getMatchedRoute(state, null);
	return matchedRoute ? matchedRoute.name : null;
};

export const getPageIsPublic = (state) => {
	const matchedRoute = getMatchedRoute(state, null);
	return matchedRoute ? matchedRoute.isPublic : false;
};

export const getPageHasNavigation = (state) => {
	const matchedRoute = getMatchedRoute(state, null);
	return matchedRoute ? matchedRoute.hasNavigation : false;
};

// user
export const getUserIsAdmin = (state) => state.getIn(["app", "user", "roles"], []).includes("logan-admin");
export const getUserRoles = (state) => state.getIn(["app", "user", "roles"], []);
export const getUserAvailableEnvironments = (state) => state.getIn(["app", "user", "environments"]);

// the user is a dev if type is developer or admin
export const selectIsDeveloper = (state) => {
	const roles = getUserRoles(state);
	return roles.includes("engineering");
};

// page query
export const getPageQuery = (state) => getMatchedRouteKeyValue(state, "query", Map());

export const getPageQueryValue = (state, query) => getPageQuery(state).get(query, "");

export const getAuthToken = (state) => state.getIn(["app", "token"], "");
export const getCurrentEnvironmentName = (state) => state.getIn(["app", "environment"], "dev");

export const getCurrentEnvironment = createSelector([getCurrentEnvironmentName], (environmentName) => {
	const environmentObject = Config.environments.find((environment) => environment.name === environmentName);

	if (!environmentObject) {
		return Config.environments[0];
	}

	return environmentObject;
});

/**
 * Returns if the requst has returned.
 * @param {string} requestName - name of the request action
 */
export const getIsRequesting = (state, requestName) => {
	const request = state.getIn(["app", "requestTracker", requestName], Map());

	if (moment.isMoment(request.get("sent")) && !moment.isMoment(request.get("received"))) {
		return true;
	}

	return false;
};
